module.exports = __webpack_public_path__ + "img/ic-tooltip2.b0157cab.svg";